module.exports = __webpack_public_path__ + "static/img/partner_XI.53276e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_XI.png
// module id = o2pD
// module chunks = 9